export class ShopifyConverter {
    static getCurrentCurrency() {
        return Shopify.currency.active ?? Shopify.currency.currentCurrency;
    }
    static getCurrentRate(target) {
        return Shopify.currency.rate ?? Shopify.currency.rates[target];
    }
    static isVanillaShopify(currentCurrency) {
        return typeof Shopify !== "undefined" && typeof Shopify.currency !== "undefined" && Shopify.currency.rate != "1.0" && Shopify.currency.active !== currentCurrency;
    }
    static isMaestroShopifyTheme() {
        return typeof Currency !== "undefined" && typeof Currency.convert !== 'undefined';
    }
    static getMaestroCurrentCurrency() {
        return Currency.currentCurrency;
    }
    static convert(price, currentCurrency) {
        if (ShopifyConverter.isVanillaShopify(currentCurrency)) {
            const current = ShopifyConverter.getCurrentCurrency();
            const rate = ShopifyConverter.getCurrentRate(currentCurrency);
            if (rate && Number(String(rate)) !== 1 && current !== currentCurrency) {
                return { price: Math.round(Number(rate) * price * 100) / 100, currency: current };
            }
        }
        else if (ShopifyConverter.isMaestroShopifyTheme()) {
            const target = ShopifyConverter.getMaestroCurrentCurrency();
            if (target && target !== currentCurrency) {
                return {
                    price: Number((Currency.convert(price, currentCurrency, target)).toFixed(2)),
                    currency: target
                };
            }
        }
        return { price, currency: currentCurrency };
    }
}
//# sourceMappingURL=shopifyConverter.js.map